<script lang="ts">
  type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info'

  interface Props {
    label: string
    tone?: Tone
  }

  let { label, tone = 'neutral' }: Props = $props()
</script>

<span class="badge badge--{tone}">{label}</span>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.1875rem 0.625rem;
    border-radius: v.$radius-pill;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.01em;
    white-space: nowrap;
    border: 1px solid transparent;

    &::before {
      content: '';
      width: 6px;
      height: 6px;
      flex-shrink: 0;
      border-radius: 50%;
      background: currentColor;
      opacity: 0.85;
    }

    &--neutral {
      background: v.$color-surface;
      color: v.$color-text-muted;
      border-color: v.$color-border;
    }

    &--success {
      background: v.$color-success-bg;
      color: v.$color-success-fg;
      border-color: rgba(22, 101, 52, 0.15);
    }

    &--warning {
      background: v.$color-warning-bg;
      color: v.$color-warning-fg;
      border-color: rgba(146, 64, 14, 0.15);
    }

    &--danger {
      background: v.$color-danger-bg;
      color: v.$color-danger-fg;
      border-color: rgba(185, 28, 28, 0.15);
    }

    &--info {
      background: v.$color-info-bg;
      color: v.$color-info-fg;
      border-color: rgba(29, 78, 216, 0.15);
    }
  }
</style>
